// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btns-wrap[data-v-b07d7194]{display:flex;justify-content:space-between;float:left;width:100%;position:relative;top:10px}.on[data-v-b07d7194]{background-color:#528deb;color:#fff}@media screen and (max-width:1000px){.overflowControlForSchedule[data-v-b07d7194]{overflow:auto}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
